// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pageRoot[data-v-0273c242]\n{\n\tmargin: 8px;\n}\n.heading[data-v-0273c242]\n{\n\tfont-size: 20px;\n\tborder-bottom: 1px solid #000000;\n\tmargin-bottom: 10px;\n\tmargin-top: 30px;\n\tmax-width: 400px;\n}\n.heading[data-v-0273c242]:first-child\n\t{\n\t\tmargin-top: 0px;\n}\n.bodySection[data-v-0273c242]\n{\n\tmargin: 0px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
